import $ from 'jquery';

$(window).on('load', function () {

	var $slider = $('.slider-inner');

	if ($slider.length) {

		$slider.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 4000,
			draggable: true,
			arrows: false,
			dots: true,
			appendDots: $('.slider-dots'),
			fade: true,
			speed: 2000,
			cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
			touchThreshold: 100
		});

		$('.first-slide-placeholder').hide();
	}

});